/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// actions 
import { updateAddOnsSetting, createAddOnsSetting } from '../../../../../../state/thunks/commenting';
// material
import { CopySnippetField } from '@insticator/insticator-ui'; // iui-material
import AddOnController from '../../../../../../material/expandablesection/controllers/addoncontroller/addoncontroller'
import ExpandableSection from '../../../../../../material/expandablesection/expandablesection';
import SectionCard from '../../../../../../material/expandablesection/sectioncard/sectioncard';
import SectionGroup from '../../../../../../material/expandablesection/sectiongroup/sectiongroup';
import SectionGroupDescription from '../../../../../../material/expandablesection/sectiongroupdescription/sectiongroupdescription';
// utils
// styles
import injectSheet from 'react-jss';
import styles from './communitysection_styles'


const CommunitySection = (props) => {
  const dispatch = useDispatch();

  const community = useSelector(state => state.commenting.commentingAddOns.addOns.community)
  const commentingUnitConfigurationUUID = useSelector(state => state.commenting.commentingConfig?.data?.commentingUnitConfigurationUUID)

  // component state
  const [isOpened, setIsOpened] = useState(false);

  const toggleSwitch = useCallback( async() => {
    if(community?.uuid) {
      const response = await dispatch(updateAddOnsSetting({
        type: 'community',
        label: 'Community',
        configurationUUID: community.uuid,
        data: {
          ...community, 
          isCommunityEnabled: !community?.isCommunityEnabled 
        }
      }))
      if(response.payload) setIsOpened(false)
    } else {
      const response = await dispatch(createAddOnsSetting({
        type: 'community',
        label: 'Community',
        data: {
          ...community, 
          commentingUnitConfigurationUUID,
          isCommunityEnabled: true
        }
      }))
    }
  }, [community, dispatch])

  const handleCancel = () => setIsOpened(false)

  const handleSave = () => {}


  const controller = () => (
    <AddOnController
      title={'Community'}
      image={'illustration-community.svg'}
      description={`Community shows the most popular discussions and top commenters on your website. 
      Enabling Community allows you to recirculate your most popular content as well as 
      highlight your most engaged commenters.`}
      isOpened={isOpened}
      setIsOpened={setIsOpened}
      toggle={community?.isCommunityEnabled}
      toggleClick={toggleSwitch}
    />
  );

  return (
    <ExpandableSection
      className={`communitysection ${props.classes.communitysection}`}
      controller={controller()}
      isOpened={isOpened}
      setIsOpened={setIsOpened}
      handleCancel={handleCancel}
      handleSave={handleSave}
      disableSave={true}
    >
      <SectionCard>
        <SectionGroup>
          <SectionGroupDescription />
            <CopySnippetField 
              title={'Community Add-On Code'} 
              description={
              <div>
                Place the Community Add-On code inside of the <strong>&lt;body&gt;</strong> tag 
                in your HTML source code where you want the Community Add-On to appear in your site.
              </div>
              } 
              codeSnippet={community?.code} 
            />
        </SectionGroup>
      </SectionCard>
    </ExpandableSection>
  );
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(CommunitySection)